import React from "react";
import CanvasSoloStartOverlay from "../CanvasSoloStartOverlay/CanvasSoloStartOverlay";
import CanvasCompeteStartOverlay from "../CanvasCompeteStartOverlay/CanvasCompeteStartOverlay";
import { connect } from "react-redux";
import "./canvasstartoverlay.style.scss";
export const CANVAS_START_OVERLAY_CLASS = "canvas-start-overay";

type Props = {
  isCompeting: boolean;
  canStartDrawing: boolean;
  fadeOut: boolean;
  canvasWidth: number;
  canvasHeight: number;
  soloStartOverlayText: string;
};

const CanvasStartOverlay = ({
  canvasWidth,
  canvasHeight,
  isCompeting,
  canStartDrawing,
  fadeOut,
  soloStartOverlayText
}: Props) => {
  return (
    <div
      className={
        fadeOut
          ? `${CANVAS_START_OVERLAY_CLASS} ${CANVAS_START_OVERLAY_CLASS}--fadeout`
          : `${CANVAS_START_OVERLAY_CLASS} ${CANVAS_START_OVERLAY_CLASS}--fadein `
      }
      style={{
        width: `${canvasWidth}px`,
        height: `${canvasHeight}px`,
        marginBottom: `-${canvasHeight}px`,
      }}
    >
      {isCompeting ? (
        <CanvasCompeteStartOverlay canStartDrawing={canStartDrawing} />
      ) : (
        <CanvasSoloStartOverlay soloStartOverlayText={soloStartOverlayText} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { canvasWidth, canvasHeight } = state;
  return {
    canvasWidth,
    canvasHeight,
  };
};

export default connect(mapStateToProps, {})(CanvasStartOverlay);
